export default __webpack_public_path__ + "static/media/marker-light-blue.6e31f7c2.svg";